import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { w } from '@dojo/framework/core/vdom';
import { I18nThemed } from 'interfaces/mixins';
import { keymap, pathmap } from 'lcc-state';
import css from '../css/related-topics.m.css';
let RelatedTopic = class RelatedTopic extends I18nThemed {
    render() {
        const { topicid, localizedBundle: { messages } } = this.properties;
        const km = keymap.get(topicid);
        const pm = pathmap.get(km.path);
        const { topicref: topic } = pm.topic;
        return w('TopicRef', { topic, messages, showShort: true });
    }
};
RelatedTopic = __decorate([
    theme(css)
], RelatedTopic);
export { RelatedTopic };
